import { generateCatalogSlug } from './slugify';

/** Segment used in public URLs for a category row (matches `PublicCategoryView` lookup). */
export function categoriaUrlSegment(categoria: { slug?: string | null; nombre: string }): string {
  const raw = (categoria.slug && String(categoria.slug).trim()) || categoria.nombre;
  return generateCatalogSlug(raw);
}

export function buildPublicCategoriaUrl(
  origin: string,
  empresaSlug: string,
  categoria: { slug?: string | null; nombre: string }
): string {
  const base = origin.replace(/\/+$/, '');
  const slugEmpresa = empresaSlug.trim();
  const catSeg = categoriaUrlSegment(categoria);
  return `${base}/${slugEmpresa}/categoria/${catSeg}`;
}

export function buildPublicColeccionUrl(
  origin: string,
  empresaSlug: string,
  coleccion: { slug: string; nombre: string }
): string {
  const base = origin.replace(/\/+$/, '');
  const slugEmpresa = empresaSlug.trim();
  const colSeg = coleccion.slug?.trim() ? generateCatalogSlug(coleccion.slug) : generateCatalogSlug(coleccion.nombre);
  return `${base}/${slugEmpresa}/coleccion/${colSeg}`;
}
